import PropTypes from 'prop-types';
import React, {Component} from 'react';

import MarkDown from 'scripts/components/MarkDown';

import LessonBlock, {LessonBlockTypes} from './LessonBlock';


class Group extends Component {

    // Returns a dictionary with the missing information for each block or just false.
    static canContinue(answer, config, extra) {
        const {types} = extra;

        const missing = {};

        answer.forEach((ans, idx) => {
            const Block = LessonBlockTypes[types[idx]];
            const missingInfo = Block && Block.canContinue(ans, config[idx]);

            if (missingInfo) {
                missing[idx] = missingInfo;
            }
        });

        return Object.keys(missing).length ? missing : false;
    }

    render() {
        const {answer, updateAnswer, blocks, missingInfo, notifyOptionalMissing} = this.props;

        return (
            <div className="group-block flex flex-col space-y-8">
                {blocks.map((block, index) => (
                    <div key={block.id} className="sub-block">
                        <MarkDown text={block.intro} />
                        <LessonBlock
                            answer={answer[index]}
                            updateAnswer={answer =>updateAnswer({[block.id]: answer})}
                            missingInfo={missingInfo && missingInfo[index]}
                            notifyOptionalMissing={notifyOptionalMissing && notifyOptionalMissing[index]}
                            {...block}
                        />
                    </div>
                ))}
            </div>
        );
    }
}

Group.propTypes = {
    answer: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string,
        }),
    ).isRequired,
    updateAnswer: PropTypes.func.isRequired,
};

export default Group;



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/Group.js